module.exports = __webpack_public_path__ + "img/enviar_a_cliente.b540adfe.svg";